import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {SingleSimulation} from '../../types/SingleSimulation'
import {Province} from '../../types/Province'
import {Dealer} from '../../types/Dealer'

export const dealerFormDataSlice = createSlice({
    name: 'dealerFormData',
    initialState: {
        dealerSimulation: [],
        dealerImageListing: '',
        allProvinces: [] as Province[],
        dealersOptions: [],
        promoIndex: 0,
    },
    reducers: {
        setDealerSimulation(
            state: RootState,
            action: PayloadAction<SingleSimulation>
        ): void {
            state.dealerSimulation = action.payload
        },
        setDealerImageListing(
            state: RootState,
            action: PayloadAction<string>
        ): void {
            state.dealerImageListing = action.payload
        },
        setProvinces(
            state: RootState,
            action: PayloadAction<Province[]>
        ): void {
            state.allProvinces = action.payload
        },
        setDealerOptions(
            state: RootState,
            action: PayloadAction<Dealer[]>
        ): void {
            state.dealersOptions = action.payload
        },
        setPromoIndex(state: RootState, action: PayloadAction<number>): void {
            state.promoIndex = action.payload
        },
    },
})

export const {
    setDealerSimulation,
    setDealerImageListing,
    setProvinces,
    setDealerOptions,
    setPromoIndex,
} = dealerFormDataSlice.actions
export default dealerFormDataSlice.reducer
